import { FC } from "react";

import { Icon, IconSource, Tag } from "@livechat/design-system-react-components";

interface IProps {
  title?: string;
  icon?: IconSource;
  removable: boolean;
  selectedValuesLabel: React.ReactNode;
  invalid?: boolean;
  wide?: boolean;
  shouldHideTitle?: boolean;
  onRemove(e?: React.MouseEvent): void;
}

export const FilterButton: FC<IProps> = ({
  title,
  icon,
  selectedValuesLabel,
  shouldHideTitle,
  onRemove,
  invalid,
  removable,
}) => (
  <Tag
    kind={invalid ? "error" : "default"}
    size="large"
    leftNode={icon && <Icon source={icon} />}
    onRemove={removable ? onRemove : undefined}
  >
    {!shouldHideTitle && title}
    {!!selectedValuesLabel && selectedValuesLabel}
  </Tag>
);
